import { H3, H2 } from 'ds/components/typography';
import styled from '@emotion/styled';
import { IListingCardsItem, ListingCardsItem } from 'ds/components/ListingCard';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { colorToAlpha } from 'helpers/insight';

export const ListingSortWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding : 0 ${theme.spacing(1)};
    width: 100%;
  `}
`;

export const QuickFiltersWrapper = styled.div(({ theme }) => ({
  margin: theme.spacing(4, 0, 3),
  minWidth: 0,
  maxWidth: '100%',
  width: '100%',
  overflow: 'hidden',
  '.scrollBox-wrapper': {
    minWidth: 0,
    maxWidth: '100%',
    width: '100%',
  },
  [theme.media.createObjectMediaQuery({ to: 3 })]: {
    marginLeft: `-${theme.spacing(3)}`,
    marginRight: `-${theme.spacing(3)}`,
    '.scrollBox': {
      padding: `1px ${theme.spacing(3)}`,
    },
  },
}));

export const MadadWinnerWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-grow: 1;
    flex-basis: 100%;
    padding: ${theme.spacing(1)} ${theme.spacing(1.5)} ${theme.spacing(3.5)};
  `}
`;

export const BlogWrapper = styled.div`
  ${({ theme }) => `
    flex-grow: 1;
    min-width: 100%;
    max-width: calc(100% + ${theme.spacing(6)});
    margin: 0 -${theme.spacing(3)} ${theme.spacing(4)};
    background-color: ${colorToAlpha(theme.colors.insights.livability, 0.12)};
    div.carousel-shadow-root .view-pager-rail {
      padding-right: 0;
    }
    > div {
      padding: ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(2)};
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 }) `
    margin: 0 -${theme.spacing(3)} ${theme.spacing(4)};
    max-width: calc(100% + ${theme.spacing(10)});
    .blog-header {
      margin-right: ${theme.spacing(2.5)};
    }
    div.carousel-shadow-root div.view-pager-rail {
      padding-right: ${theme.spacing(6.5)};
    }
    > div {
      padding-left: 0;
      padding-right: 0;
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    margin: 0 -${theme.spacing(2)} ${theme.spacing(1.5)};
    max-width: calc(100% + ${theme.spacing(4)});
    .blog-header {
      padding-right: ${theme.spacing(3.5)};
    }
    div.carousel-shadow-root div.view-pager-rail {
      padding-right: ${theme.spacing(3.5)};
    }
    > div {
      padding-left: 0;
      padding-right: 0;
    }
  `}
`;


export const ListingSeparatorH3Header = styled(H3)<{withTopBorder?: boolean}>`
  ${({ theme, withTopBorder }) => `
    margin-bottom: ${theme.spacing(2)};
    padding: ${theme.spacing(1)};
    font-weight: bold;
    width: 100%;
    ${withTopBorder ? `
      padding-top: ${theme.spacing(3)};
      border-top: 1px solid ${theme.colors.neutrals.grey8};
    ` : ''}
  `}
`;

const SearchSubtitle = styled(H3)<{ isSingleAddress?: boolean; isCommercial?: boolean }>`
  ${({ theme, isCommercial }) => `
    margin-top: ${theme.spacing(isCommercial ? 0.5 : 2)};
    margin-bottom: ${theme.spacing(1)};
    ${isCommercial ? `
      color: ${theme.colors.neutrals.grey1};
      font-weight: normal;
    ` : ''}
  `}
  ${({ theme, isSingleAddress }) => theme.media.showAt({ at: 1 }) `
    margin-top: ${theme.spacing(4)};
    margin-bottom: ${isSingleAddress ? theme.spacing(5) : 0};
  `}
`;

export const SearchSubtitleH2 = styled(SearchSubtitle.withComponent('h2'))`
  ${({ theme }) => `
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
export const SearchSubtitleH3 = styled(SearchSubtitle.withComponent('h3'))``;

export const PageH1 = styled(H2.withComponent('h1'))`
  > span {
    color: transparent;
    user-select: none;
  }
`;

export const PageH2 = styled(H3.withComponent('h2'))`
  ${({ theme }) => `
    margin-top: ${theme.spacing(1)};
  `}
`;

interface ListingCardsItemModeBProps extends IListingCardsItem {
  view?: SearchViewMode;
  useListOnly?: boolean;
}


export const ListingCardsItemModeB = styled(ListingCardsItem)<ListingCardsItemModeBProps>`
  flex-basis: 100%;
  margin: 0;
  ${({ view, theme }) => theme.media.showAt({ from: 4 })`
    ${view === SearchViewMode.Grid ? `
      flex-basis: calc((100% - ${theme.spacing(1)} ) / 3);
    ` : ''}
  `}

  ${({ view, theme, useListOnly }) => !useListOnly && theme.media.showAt({ from: 2, to: 3 })`
    ${view === SearchViewMode.Grid ? `
      flex-basis: calc((100% - ${theme.spacing(0.5)}) / 2);
    ` : ''}
  `}
`;

